// extracted by mini-css-extract-plugin
export default {"loader":"ProcessingStage_loader__FUzCk","loaderText":"ProcessingStage_loaderText__bOlqP","banner":"ProcessingStage_banner__DNWpy","bannerText":"ProcessingStage_bannerText__ikmW8"};